// Customer-brand exclusions requested by Jan, 2026-09-10.
// Source: https://interbrand.com/best-global-brands/global/ (2025 Top 100).
// This is an admission policy, not an assertion about the applicant's identity.
// Keep the JSON-compatible array: the migration generator reads it verbatim.
export const RESTRICTED_BRANDS = [
  { "name": "Apple", "aliases": [], "domains": ["apple.com"] },
  { "name": "Microsoft", "aliases": [], "domains": ["microsoft.com"] },
  { "name": "Amazon", "aliases": [], "domains": ["amazon.com", "amazon.de", "amazon.co.uk"] },
  { "name": "Google", "aliases": ["Alphabet"], "domains": ["google.com", "google.de", "google.co.uk", "abc.xyz"] },
  { "name": "Samsung", "aliases": ["Samsung Electronics"], "domains": ["samsung.com"] },
  { "name": "Toyota", "aliases": [], "domains": ["toyota.com", "toyota.de", "toyota.co.uk"] },
  { "name": "Coca-Cola", "aliases": ["Coca Cola", "Coke"], "domains": ["coca-cola.com", "coca-cola.de"] },
  { "name": "Instagram", "aliases": [], "domains": ["instagram.com"] },
  { "name": "McDonald's", "aliases": ["McDonalds"], "domains": ["mcdonalds.com", "mcdonalds.de"] },
  { "name": "Mercedes-Benz", "aliases": ["Mercedes Benz", "Mercedes"], "domains": ["mercedes-benz.com", "mercedes-benz.de"] },
  { "name": "Cisco", "aliases": ["Cisco Systems"], "domains": ["cisco.com"] },
  { "name": "Louis Vuitton", "aliases": [], "domains": ["louisvuitton.com"] },
  { "name": "YouTube", "aliases": [], "domains": ["youtube.com"] },
  { "name": "BMW", "aliases": [], "domains": ["bmw.com", "bmw.de", "bmw.co.uk"] },
  { "name": "NVIDIA", "aliases": [], "domains": ["nvidia.com"] },
  { "name": "Oracle", "aliases": [], "domains": ["oracle.com"] },
  { "name": "Disney", "aliases": ["Walt Disney"], "domains": ["disney.com", "disney.de"] },
  { "name": "SAP", "aliases": [], "domains": ["sap.com"] },
  { "name": "Facebook", "aliases": ["Meta", "Meta Platforms"], "domains": ["facebook.com", "meta.com"] },
  { "name": "Adobe", "aliases": [], "domains": ["adobe.com"] },
  { "name": "Hermès", "aliases": ["Hermes"], "domains": ["hermes.com"] },
  { "name": "IBM", "aliases": ["International Business Machines"], "domains": ["ibm.com"] },
  { "name": "Nike", "aliases": ["Nike Tech", "Nike Tech Joggers", "Nike Sportswear", "Nike Air"], "domains": ["nike.com"] },
  { "name": "Chanel", "aliases": [], "domains": ["chanel.com"] },
  { "name": "Tesla", "aliases": [], "domains": ["tesla.com"] },
  { "name": "J.P. Morgan", "aliases": ["JP Morgan", "JPMorgan Chase", "Chase"], "domains": ["jpmorgan.com", "jpmorganchase.com", "chase.com"] },
  { "name": "Allianz", "aliases": [], "domains": ["allianz.com", "allianz.de"] },
  { "name": "Netflix", "aliases": [], "domains": ["netflix.com"] },
  { "name": "Honda", "aliases": [], "domains": ["honda.com", "honda.de"] },
  { "name": "Hyundai", "aliases": [], "domains": ["hyundai.com"] },
  { "name": "BlackRock", "aliases": [], "domains": ["blackrock.com"] },
  { "name": "Booking.com", "aliases": ["Booking"], "domains": ["booking.com"] },
  { "name": "Visa", "aliases": [], "domains": ["visa.com", "visa.de"] },
  { "name": "Sony", "aliases": [], "domains": ["sony.com", "sony.de"] },
  { "name": "IKEA", "aliases": [], "domains": ["ikea.com"] },
  { "name": "Mastercard", "aliases": ["Master Card"], "domains": ["mastercard.com", "mastercard.de"] },
  { "name": "Accenture", "aliases": [], "domains": ["accenture.com"] },
  { "name": "Pepsi", "aliases": ["PepsiCo"], "domains": ["pepsi.com", "pepsico.com"] },
  { "name": "Qualcomm", "aliases": [], "domains": ["qualcomm.com"] },
  { "name": "PayPal", "aliases": [], "domains": ["paypal.com"] },
  { "name": "Zara", "aliases": [], "domains": ["zara.com"] },
  { "name": "Salesforce", "aliases": [], "domains": ["salesforce.com"] },
  { "name": "AXA", "aliases": [], "domains": ["axa.com", "axa.de"] },
  { "name": "GE Aerospace", "aliases": ["General Electric"], "domains": ["geaerospace.com", "ge.com"] },
  { "name": "Airbnb", "aliases": [], "domains": ["airbnb.com", "airbnb.de"] },
  { "name": "UPS", "aliases": ["United Parcel Service"], "domains": ["ups.com"] },
  { "name": "UNIQLO", "aliases": [], "domains": ["uniqlo.com"] },
  { "name": "Siemens", "aliases": [], "domains": ["siemens.com", "siemens.de"] },
  { "name": "Adidas", "aliases": [], "domains": ["adidas.com", "adidas.de", "adidas.co.uk"] },
  { "name": "LEGO", "aliases": [], "domains": ["lego.com"] },
  { "name": "Dell", "aliases": ["Dell Technologies"], "domains": ["dell.com"] },
  { "name": "Audi", "aliases": [], "domains": ["audi.com", "audi.de"] },
  { "name": "Nintendo", "aliases": [], "domains": ["nintendo.com", "nintendo.de"] },
  { "name": "Ferrari", "aliases": [], "domains": ["ferrari.com"] },
  { "name": "Goldman Sachs", "aliases": [], "domains": ["goldmansachs.com"] },
  { "name": "Volkswagen", "aliases": ["VW"], "domains": ["volkswagen.com", "volkswagen.de", "vw.com"] },
  { "name": "Porsche", "aliases": [], "domains": ["porsche.com"] },
  { "name": "Spotify", "aliases": [], "domains": ["spotify.com"] },
  { "name": "L'Oréal Paris", "aliases": ["L'Oreal", "Loreal", "Loreal Paris"], "domains": ["loreal.com", "lorealparis.com", "lorealparis.de", "lorealparisusa.com"] },
  { "name": "Pampers", "aliases": [], "domains": ["pampers.com", "pampers.de"] },
  { "name": "eBay", "aliases": [], "domains": ["ebay.com", "ebay.de", "ebay.co.uk"] },
  { "name": "Citi", "aliases": ["Citibank", "Citigroup"], "domains": ["citi.com", "citibank.com"] },
  { "name": "Nescafé", "aliases": [], "domains": ["nescafe.com"] },
  { "name": "Uber", "aliases": [], "domains": ["uber.com"] },
  { "name": "Schneider Electric", "aliases": [], "domains": ["se.com", "schneider-electric.com"] },
  { "name": "Budweiser", "aliases": [], "domains": ["budweiser.com"] },
  { "name": "HP", "aliases": ["Hewlett Packard", "Hewlett-Packard"], "domains": ["hp.com"] },
  { "name": "H&M", "aliases": ["Hennes and Mauritz", "Hennes & Mauritz"], "domains": ["hm.com"] },
  { "name": "Gucci", "aliases": [], "domains": ["gucci.com"] },
  { "name": "Monster", "aliases": ["Monster Energy"], "domains": ["monsterenergy.com"] },
  { "name": "Intel", "aliases": [], "domains": ["intel.com", "intel.de"] },
  { "name": "HSBC", "aliases": [], "domains": ["hsbc.com"] },
  { "name": "Cartier", "aliases": [], "domains": ["cartier.com"] },
  { "name": "Philips", "aliases": [], "domains": ["philips.com", "philips.de"] },
  { "name": "LinkedIn", "aliases": [], "domains": ["linkedin.com"] },
  { "name": "Colgate", "aliases": [], "domains": ["colgate.com"] },
  { "name": "Santander", "aliases": ["Banco Santander"], "domains": ["santander.com", "santander.de"] },
  { "name": "Gillette", "aliases": [], "domains": ["gillette.com", "gillette.de"] },
  { "name": "Nestlé", "aliases": [], "domains": ["nestle.com", "nestle.de"] },
  { "name": "Corona", "aliases": ["Corona Extra"], "domains": ["corona.com", "coronaextra.com"] },
  { "name": "Xiaomi", "aliases": [], "domains": ["mi.com", "xiaomi.com"] },
  { "name": "Nissan", "aliases": [], "domains": ["nissan-global.com", "nissanusa.com", "nissan.de"] },
  { "name": "Dior", "aliases": ["Christian Dior"], "domains": ["dior.com"] },
  { "name": "Caterpillar", "aliases": [], "domains": ["caterpillar.com", "cat.com"] },
  { "name": "Nasdaq", "aliases": [], "domains": ["nasdaq.com"] },
  { "name": "Prada", "aliases": [], "domains": ["prada.com"] },
  { "name": "3M", "aliases": [], "domains": ["3m.com", "3m.de"] },
  { "name": "John Deere", "aliases": [], "domains": ["deere.com", "deere.de"] },
  { "name": "Kia", "aliases": [], "domains": ["kia.com"] },
  { "name": "BYD", "aliases": [], "domains": ["byd.com"] },
  { "name": "Danone", "aliases": [], "domains": ["danone.com", "danone.de"] },
  { "name": "FedEx", "aliases": [], "domains": ["fedex.com"] },
  { "name": "Sephora", "aliases": [], "domains": ["sephora.com", "sephora.de"] },
  { "name": "Tiffany & Co.", "aliases": ["Tiffany", "Tiffany and Co"], "domains": ["tiffany.com", "tiffany.de"] },
  { "name": "Pandora", "aliases": ["Pandora Jewelry"], "domains": ["pandora.net"] },
  { "name": "Huawei", "aliases": [], "domains": ["huawei.com"] },
  { "name": "Range Rover", "aliases": [], "domains": ["rangerover.com"] },
  { "name": "Nespresso", "aliases": [], "domains": ["nespresso.com"] },
  { "name": "Shopify", "aliases": [], "domains": ["shopify.com"] },
  { "name": "DHL", "aliases": [], "domains": ["dhl.com", "dhl.de"] }
] as const;
